import { axiosUser } from '@axios/axiosInstances';
export const getGroups = async () => {
  const res = await axiosUser.get(`/shopMemberGroup/`);

  return res;
};

export const addGroup = newGroup => {
  return axiosUser.post(`/shopMemberGroup/`, newGroup);
};

export const deleteGroup = ({ newGroupId, groupId }) => {
  return axiosUser.delete(`/shopMemberGroup/${groupId}/${newGroupId}`);
};

export const updateGroup = (groupForm, groupId) => {
  return axiosUser.put(`/shopMemberGroup/${groupId}`, groupForm);
};

export const syncPointGroups = isKeepCurrentGroup =>
  axiosUser.post(`/shopMemberGroup/sync-groups`, { isKeepCurrentGroup });

export const updateTierSetting = tierSetting => {
  return axiosUser.patch(`/shopMemberGroup/tier-setting`, tierSetting);
};
